<template>
  <div>
    <Loader bgColor="#fff" v-if="isLoading"></Loader>
    <template v-else>
      <div class="do-table__filters">
        <div class="do-table__filters__left">
          <DoFiltersFilter
            title="Grupper"
            :tags="tags"
            :selectedTags="selectedTags"
            @select="toggleTag"
            @clear="selectedTags = []">
          </DoFiltersFilter>
          <DoFiltersFilter
            v-if="organisations.length > 1"
            title="Organisationer"
            :tags="organisations"
            :selectedTags="selectedOrganisations"
            @select="selectedOrganisation"
            @clear="selectedOrganisations = []">
          </DoFiltersFilter>
        </div>
        <div class="do-table__filters__add">
          <span>Viser {{ filteredUsers.length }} af {{ users.length }} brugere</span>
        </div>
      </div>
      <SalarySettingsUsersTable
        :isSalaryIntegrationActive="isSalaryIntegrationActive"
        :filteredUsers="filteredUsers"
        :isImportOfEmployments="true"
        @editEmployment="$emit('editEmployment', $event)"
        @setTheEditUser="$emit('setTheEditUser', $event)"
      >
      </SalarySettingsUsersTable>
    </template>
  </div>
</template>
<script>
import DModal from '../../common/DModal.vue'
import Loader from '../../common/Loader.vue'
import SalarySettingsUsersTable from './SalarySettingsUsersOpusTable.vue'
import DoFiltersFilter from '../../DoFilters/DoFiltersFilter.vue'
import TaggingFilter from '../../Tagging/TaggingFilter.vue'

export default {
  components: {TaggingFilter, DoFiltersFilter, SalarySettingsUsersTable, Loader, DModal},
  props: {
    users: {
      default: () => []
    },
    employments: {
      default: () => []
    },
    tags: {
      default: () => []
    },
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      selectedOrganisations: [],
      selectedTags: [],
      selectedEmployments: []
    }
  },
  computed: {
    organisations () {
      const organisations = new Set()
      this.employments.forEach(employment => {
        if (employment.organisation) {
          organisations.add(employment.organisation)
        }
      })
      return Array.from(organisations).sort((a, b) => a.localeCompare(b, 'da-DK'))
    },
    filteredEmployments () {
      return this.employments.filter(employment => this.selectedOrganisations.length > 0 ? this.selectedOrganisations.indexOf(employment.organisation) > -1 : true)
    },
    filteredUsers () {
      const getEmploymentsForUser = (userId) => {
        return this.filteredEmployments.filter(employment => employment.user_id === userId)
      }
      return this.users.filter(user => {
        if (this.selectedTags.length > 0) {
          return user.user_tags.some(tag => this.selectedTags.includes(tag))
        } else {
          return true
        }
      }).map(user => {
        return {
          ...user,
          v_employments: getEmploymentsForUser(user.id).sort((a, b) => a.title.localeCompare(b.title, 'da-DK'))
        }
      })
    }
  },
  methods: {
    toggleTag (tag) {
      const idx = this.selectedTags.indexOf(tag)
      if (idx > -1) {
        this.selectedTags.splice(idx, 1)
      } else {
        this.selectedTags.push(tag)
      }
    },
    selectedOrganisation (organisation) {
      const idx = this.selectedOrganisations.indexOf(organisation)
      if (idx > -1) {
        this.selectedOrganisations.splice(idx, 1)
      } else {
        this.selectedOrganisations.push(organisation)
      }
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.d-modal {
  width: calc(100vw - 3rem);
  height: calc(100vw - 3rem);
  border-radius: 16px;
  position: relative;
}

.d-modal__white {
  background: #fff;
}

.d-modal__header__custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 0 1rem;
}

.do-table__filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  border-bottom: 0;
  padding: 8px;
  border-radius: 4px 4px 0 0;
}

.do-table__filters__left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-table__filters__add {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.do-table__filters__add span {
  font-style: italic;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// SalarySettingsUsersOpus.vue?2e049300